export const MEDIA_TYPES = {
  IMAGE: 'IMAGE',
  VIDEO: 'VIDEO',
}

export const isVideo = mediaType => mediaType === MEDIA_TYPES.VIDEO

export const getAcceptedTypes = mediaType =>
  isVideo(mediaType) ? 'video/*' : 'image/*'

export const getMaxFileSize = mediaType => (isVideo(mediaType) ? 200 : 20)

export const toDateInputValue = value => {
  if (!value) return ''
  return new Date(value).toISOString().split('T')[0]
}

export const buildCustomerDisplayPayload = ({
  values,
  fileUrl,
  editMode,
  customerDisplaySettingId,
}) => {
  const payload = {
    Name: values.name,
    MediaType: values.mediaType,
    FileUrl: fileUrl,
    DisplayOrder: values.displayOrder || undefined,
    StartDate: new Date(values.startDate).toISOString(),
    EndDate: new Date(values.endDate).toISOString(),
    CompanyId: values.companyId,
    Status: editMode ? values.status : true,
    BranchOffices: (values.branchOfficeIds || []).map(branchOfficeId => ({
      BranchOfficeId: branchOfficeId,
    })),
  }

  if (editMode) {
    payload.CustomerDisplaySettingId = customerDisplaySettingId
  }

  return payload
}
